module.exports = __webpack_public_path__ + "img/ava-6.1fa1722b.webp";